import { Injectable } from "@angular/core";
import { RemoteRepositoryInterface } from "../../remote/remote.interface";
import { MediaRepositoryInterface } from "./media.interface";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ListInfo } from "../../entities/listinfo.model";
import { MediaModel } from "../../entities/media.model";
import { GetPayload } from "../../../crossconcern/types/payload.types";

@Injectable()
export class MediaRepository implements MediaRepositoryInterface {

    constructor(private remoteRepository: RemoteRepositoryInterface) {}

    public getMediasByEntity(searchString: string, entityUuid?: string): Observable<[ListInfo, MediaModel[]]> {
        let endpoint = "media";
        if (entityUuid) {
            endpoint = "media/entities/" + entityUuid;
        }
        if(searchString) {
            endpoint = endpoint + "?" + searchString;
        }
        return this.remoteRepository.get(endpoint)
            .pipe(
                map((data: GetPayload) => {
                    const items: MediaModel[] = [];
                    for (const item of data.content) {
                        items.push(new MediaModel(item as JSON));
                    }
                    const listInfo = new ListInfo(data);
                    return [
                        listInfo, items
                    ];
                })
            );
    }

    public addMedia(body: FormData, entityUuid: string, customTag: string): Observable<MediaModel> {
        let url = "media";
        const params = [];
        if (entityUuid) {
            params.push("uuid=" + entityUuid);
        }
        if (customTag) {
            params.push("custom_tag=" + customTag);
        }
        if (params.length > 0) {
            url += "?" + params.join("&");
        }
        return this.remoteRepository.post(url, body)
            .pipe(
                map((data) => new MediaModel(data as JSON))
            );
    }
}